(ns ycweb.components.datepicker
  (:require
   [rum.core :as rum]
   [ycweb.util.core :as u]
   [util.string :as str]
   [ycweb.components.forms :as forms]
   [ycweb.util.date :as ud]
   #?@(:clj
       [[clj-time.core :as dt]
        [clj-time.format :as dtfmt]])
   #?@(:cljs
       [[cljs-time.core :as dt]
        [cljs-time.format :as dtfmt]])
   [ycweb.components.common :as cmn]
   [ycweb.components.buttons :as buttons]))

(defn datepicker-modal-cursor
  [app-atom]
  (rum/cursor app-atom :datepicker-modal))

(rum/defc datepicker-month < rum/reactive [config-atom]
  (let [selected-atom (rum/cursor config-atom :selected-date)
        month-atom (rum/cursor config-atom :month)
        time-picker (cmn/curact config-atom [:time-picker])
        month (or (rum/react month-atom) (dt/now))
        selected (rum/react selected-atom)

        min-date (cmn/curact config-atom :min-date)
        disable-dow (cmn/curact config-atom :disable-dow)

        current (dt/now)
        start-day (dt/first-day-of-the-month month)
        start-dow (dec (dt/day-of-week start-day))
        days-split
        (->>
          (concat
            (map (fn [_] {:text ""}) (range start-dow))
            (map (fn [n] {:text (str (inc n)) :n n :dt (dt/plus start-day (dt/days n))})
              (range (dt/number-of-days-in-the-month month))))
          (partition-all 7))
        [range-start range-end] []]

    [:div.calendar.u-max-width-480.u-block-center
     [:nav.calendar-nav
      [:div.calendar-nav__prev
       (buttons/button [:span.u-hidden-from-view "Previous Month"]
         (fn [] (swap! month-atom #(dt/minus % (dt/months 1))))
         {:secondary true
          :raised true
          :small true
          :icon-only [:2-1 :arrow-left :small]
          :class :button--circle})]

      [:div.calendar-nav__title-wrapper
       [:h2.calendar-nav__title.u-text-center
        {:class (u/bem :heading [:flush :standard])}
        [:span.calendar-nav__month
         (dtfmt/unparse (dtfmt/formatter "MMMM") month)]
        " "
        [:span.calendar-nav__year (dtfmt/unparse (dtfmt/formatter "yyyy") month)]]]
      [:div.calendar-nav__next
       (buttons/button [:span.u-hidden-from-view "Next Month"]
         (fn [] (swap! month-atom #(dt/plus % (dt/months 1))))
         {:secondary true
          :raised true
          :small true
          :icon-only [:2-1 :arrow-right :small]
          :class :button--circle})]]
     [:table.calendar__month
      [:thead
       (into
         [:tr.calendar__days-of-week]
         (map
           (fn [n] [:th.calendar__day-title {:scope "col"} n])
           ["Mon" "Tue" "Wed" "Thu" "Fri" "Sat" "Sun"]))]

      (into
        [:tbody]
        (map
          (fn [days]
            (into
              [:tr.calendar__week]
              (map
                (fn [{:keys [text n dt]}]
                  (let [day-selected? (and dt selected (zero? (ud/compare-local-dates selected dt)))
                        enabled?
                        (and
                          (or
                            (nil? min-date)
                            (and dt min-date (dt/after? dt min-date)))
                          (or
                            (empty? disable-dow)
                            (not (contains? disable-dow (dt/day-of-week dt)))))]
                    [:td
                     {:on-click
                      (when (and enabled? dt)
                        #(swap! selected-atom
                           (fn [d]
                             (if d
                               (->
                                 (ud/at-midnight dt)
                                 (dt/plus (dt/hours (dt/hour d)))
                                 (dt/plus (dt/minutes (dt/minute d))))
                               (ud/at-midnight dt)))))
                      :class
                      (u/bem :calendar__day
                        (cond
                          (not enabled?) [:is-disabled]
                          (not dt) [:is-other-month]

                          :else
                          [(when (= n 0) :is-first-day)
                           (when (= (inc n) (dt/day (dt/last-day-of-the-month dt))) :is-last-day)
                           (when (and (not day-selected?) (zero? (ud/compare-local-dates current dt))) :is-current)

                           (when day-selected? :is-active-point)

                           ;; Range view logic.
                           (when (and range-start range-end (dt/after? dt range-start) (dt/before? dt range-end)) :is-active)
                           (when (and range-start (zero? (ud/compare-local-dates range-start dt))) :is-active-start-point)
                           (when (and range-end (zero? (ud/compare-local-dates range-end dt))) :is-active-end-point)]))}
                     [:div.calendar__day-wrapper
                      [:div.calendar__day-number text]]]))
                (take 7 (concat days (repeat {:text ""}))))))
          days-split))]
     (when time-picker
       [:div [:div.u-hr]
        [:h3.u-margin-bottom-8
         {:class (u/bem :heading [:flush :standard])}
         "Start time:"]
        [:div
         {:class (u/bem :flex-grid-group [:flush-force])}
         [:div
          {:class (u/bem :flex-grid-block [:t-1-2])}
          [:div.form-field.js-form-field.flex-grid-content
           ;; TODO: Skylar: something weird with these select boxes, you can't click the arrow icon itself?
           [:label.form-label.js-form-label "Hours:"]
           [:div.select-wrapper
            (forms/select-raw (rum/derived-atom [selected-atom] ::d (fn [dt] (dt/hour dt)))
              (map (fn [h] {:value h :text (str/format "%02d" h)}) (range 24))
              {:change-fn
               (fn [n v]
                 (swap! selected-atom
                   #(->
                      %
                      (dt/minus (dt/hours (dt/hour %)))
                      (dt/plus (dt/hours (int v))))))})
            [:i.select-icon]]]]
         [:div
          {:class (u/bem :flex-grid-block [:t-1-2])}
          [:div.form-field.js-form-field.flex-grid-content
           [:label.form-label.js-form-label "Minutes:"]
           [:div.select-wrapper
            (forms/select-raw (rum/derived-atom [selected-atom] ::d (fn [dt] (dt/minute dt)))
              (map (fn [h] {:value (* 10 h) :text (str/format "%02d" (* 10 h))}) (range 6))
              {:change-fn
               (fn [n v]
                 (swap! selected-atom
                   #(->
                      %
                      (dt/minus (dt/minutes (dt/minute %)))
                      (dt/plus (dt/minutes (int v))))))})

            [:i.select-icon]]]]]])]))

(defn close-datepicker-modal [app-atom]
  (let [modal-atom (datepicker-modal-cursor app-atom)
        modal-uuid (u/rand-uuid)]
    (swap! modal-atom assoc :open false :opening false :uuid modal-uuid)

    #?(:cljs
       (.setTimeout js/window
         #(when (= modal-uuid (:uuid @modal-atom))
            (swap! modal-atom assoc :open false :opening false))
         200))))

(rum/defc datepicker-body < rum/reactive [_ config-atom]
  (let [{:keys [header error] :as local-state} (rum/react config-atom)]

    [:div.modal__content
     [:h2
      {:class (u/bem :heading [:medium-large])}
      header]

     (case (:view local-state)
       :single-month
       (datepicker-month config-atom)
       nil)

     (when error
       [:p {:class (u/bem :feedback [:error])}
        error])]))

(defn datepicker-footer [app-atom config-atom]
  (let [{:keys [path extra-on-click selected-date]} @config-atom]
    [:div.modal__footer
     [:div
      {:class (u/bem :flex-grid-group [:flush])}
      [:div
       {:class (u/bem :flex-grid-block [:flush :1-2])}
       [:div.flex-grid-content
        [:a.js-modal__close-button
         {:class
          (u/bem :button [:flat :persistent :secondary :full :large])
          :on-click #(close-datepicker-modal app-atom)}
         [:span.button__text "Cancel"]]]]
      [:div
       {:class (u/bem :flex-grid-block [:flush :1-2])}
       [:div.flex-grid-content
        [:a.js-modal__close-button
         {:class
          (u/bem :button [:flat :persistent :primary :full :large])
          :on-click
          #(let [{:keys [prevent-default? error]}
                 (when extra-on-click
                   (extra-on-click app-atom selected-date))]
             (cond
               prevent-default?
               (swap! config-atom assoc :error error)

               :else
               (do
                 (swap! config-atom dissoc :error)
                 (reset! (rum/cursor-in app-atom path) (ud/from-default-time-zone selected-date))
                 (close-datepicker-modal app-atom))))}
         [:span.button__text "Apply"]]]]]]))

(rum/defc datepicker-modal < rum/reactive
  [app-atom]
  (let [modal-atom (datepicker-modal-cursor app-atom)
        {:keys [open config] :as modal-state} (rum/react modal-atom)]

    [:div
     {:class
      (u/bem :modal
        [:has-footer :variable :small
         (when open :is-open)])
      :style
      (merge {} (:style config))}

     (when open
       (datepicker-body app-atom (rum/cursor modal-atom :config)))
     (when open
       [:div.modal__footer
        (datepicker-footer app-atom (rum/cursor modal-atom :config))])

     (when (and open (not (:requires-action config)))
       [:a.modal__close-button
        {:on-click #(close-datepicker-modal app-atom)}
        [:i {:class (u/bem :icon [:4-1 :close :block])}]])]))

(rum/defc datepicker-modal-background < rum/reactive
  [app-atom]
  (let [{:keys [opening]} (rum/react (datepicker-modal-cursor app-atom))]
    [:div
     {:class (u/bem :modal-overlay [(when opening :is-open)])
      :on-click #(close-datepicker-modal app-atom)}]))

(defn open-datepicker [app-atom date-path options]
  (let [modal-atom (datepicker-modal-cursor app-atom)
        current
        (ud/clamp-time
          10
          (ud/to-default-time-zone (or (get-in @app-atom date-path) (dt/now)))
          false)]

    (swap! modal-atom assoc
      :open true
      :opening true
      :config
      (merge
        options
        {:path date-path
         :selected-date current
         :month current
         :view :single-month}))))

(rum/defc raw-datepicker < rum/reactive
  [app-atom placeholder date-path &
   [{:keys [datatype hint time-picker extra-on-click small-width error header disable-dow min-date field-classes] :as options}]]
  [:div.text-input-wrapper
   {:class (when small-width "u-max-width-128")
    :on-click #(open-datepicker app-atom date-path options)}
   (forms/input-raw placeholder
     (rum/cursor-in app-atom date-path)
     (assoc options
       :datatype datatype
       :type :date
       :read-only true))
   [:i.text-input-icon]])

(rum/defc datepicker < rum/reactive
  [app-atom label placeholder date-path &
   [{:keys [datatype hint time-picker extra-on-click small-width error header disable-dow min-date field-classes] :as options}]]
  [:div.js-form-field
   {:class (u/bem :form-field [(when error :error) (when field-classes field-classes)])}
   (forms/field-label label options)
   (raw-datepicker app-atom placeholder date-path options)
   (when error
     [:div.form-hint-wrapper
      [:span.form-hint.js-form-hint error]])
   (when hint
     [:div.form-hint-wrapper
      [:span.form-hint.js-form-hint hint]])])


